import { withWizardRefetch } from "../withWizardRefetch.js";
import { useItemTypeMenuItem_ChangeItemTypeMutation } from "./ItemTypeMenuItem.generated.js";

export const useItemTypeMenuItem_ChangeItemTypeMutationWithWizardRefetch =
  withWizardRefetch(useItemTypeMenuItem_ChangeItemTypeMutation);
